// extracted by mini-css-extract-plugin
export default {"seniorityTooltip":"tooltips_seniorityTooltip__9+cTr","jobTitleTooltip":"tooltips_jobTitleTooltip__CWN4k"};